/**
 * @typedef {Object} MacroIndicator
 * @property {string} id
 * @property {string} name
 * @property {string} value
 * @property {string} [prevValue]
 * @property {string} [delta]
 * @property {'up'|'down'|'flat'} deltaDirection
 * @property {'bullish'|'bearish'|'neutral'|'warning'} signal
 * @property {string} date
 * @property {string} source
 * @property {string} sourceUrl
 * @property {string} analysis
 * @property {string} [ewRelevance]
 */

/**
 * @typedef {Object} YieldPoint
 * @property {string} maturity
 * @property {number} yield
 * @property {number} [prevYield]
 * @property {number} [delta]
 */

/**
 * @typedef {Object} ChartDataPoint
 * @property {string} date
 * @property {number} value
 * @property {string} [label]
 */

/**
 * @typedef {Object} MarketAsset
 * @property {string} symbol
 * @property {string} name
 * @property {number} price
 * @property {number} change
 * @property {number} changePercent
 * @property {number} yearLow
 * @property {number} yearHigh
 * @property {'bullish'|'bearish'|'neutral'} signal
 */

/**
 * @typedef {Object} RiskItem
 * @property {string} category
 * @property {'low'|'medium'|'high'|'critical'} level
 * @property {string} description
 * @property {string} impact
 */

/**
 * @typedef {'overview'|'rates'|'inflation'|'growth'|'labor'|'risk'|'warroom'|'timeline'|'assets'|'crypto'|'liquidity'} TabId
 */

export const TABS = [
  { id: 'warroom', label: 'WAR ROOM', key: '1' },
  { id: 'overview', label: 'OVERVIEW', key: '2' },
  { id: 'rates', label: 'RATES', key: '3' },
  { id: 'inflation', label: 'INFLATION', key: '4' },
  { id: 'growth', label: 'GROWTH', key: '5' },
  { id: 'labor', label: 'LABOR', key: '6' },
  { id: 'risk', label: 'RISK', key: '7' },
  { id: 'timeline', label: 'TIMELINE', key: '8' },
  { id: 'assets', label: 'ASSETS', key: '9' },
  { id: 'crypto', label: 'CRYPTO', key: '0' },
  { id: 'liquidity', label: 'LIQUIDITY', key: '-' },
];
